import toastr from 'toastr';
// eslint-disable-next-line import/extensions
import 'src/styles/toastr.css';
import 'toastr/build/toastr.min.css';
import { useCallback, useEffect } from 'react';

export const useToastr = (options?: typeof toastr.options) => {
  useEffect(() => {
    if (toastr && options) {
      toastr.options = options;
      return;
    }

    toastr.options = {
      positionClass: 'toast-top-center',
    };
  }, [toastr, options]);

  const toastrClear = useCallback(() => {
    toastr.clear();
  }, [toastr, options]);

  const toastrSuccess = useCallback((text?: string) => {
    toastr.success(text || 'Changes saved');
  }, [toastr, options]);

  const toastrError = useCallback((text?: string) => {
    toastr.error(text || 'Something went wrong');
  }, [toastr, options]);

  return {
    toastrClear,
    toastrSuccess,
    toastrError,
  };
};
